<template>
  <div>
    <b-container fluid>
      <h3 class="mt-3 mb-3">Collection Note</h3>

      <div class="search_bar mb-1">
        <b-card>
          <b-row>
            <b-col cols="2" class="pl pr-1">
              <b-form-input id="input-small" size="sm" type="date"
                v-model="search_criteria.collection_date"></b-form-input>
            </b-col>
            <!-- <b-col cols="4" class="pl pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="text"
                placeholder="CN#"
                v-model="search_criteria.keyword"
              ></b-form-input>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="date"
                v-model="search_criteria.start_at"
              ></b-form-input>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="date"
                v-model="search_criteria.end_at"
              ></b-form-input>
            </b-col> -->
            <b-col class="text-left p-0">
              <!-- <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
                <font-awesome-icon class="mr-1" icon="search" />Search
              </b-button> -->

              <b-button class="btn-action" size="sm" variant="info" @click="exportCSV">Export</b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <!-- <div class="search_bar mb-3">
        <b-row>
          <b-col class="text-left">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="bulkDownloadWayBill()"
              >Bulk Download Waybill</b-button
            >
          </b-col>
        </b-row>
      </div> -->
      <div v-if="false">
        <strong># of Records: {{ total_rows }}</strong>
        <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
          @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>

        <b-table responsive small outlined striped hover :items="items" :fields="fields" :tbody-tr-class="rowClass">
          <template v-slot:head(chk_box)="data">
            <b-form-checkbox size="sm" plain id="chkbox_all" value="all" v-model="check_all_rows"></b-form-checkbox>
          </template>
          <template v-slot:cell(chk_box)="data">
            <b-form-checkbox size="sm" class="chkbox_row" plain :id="'chkbox_row_' + data.index"
              v-model="data.item.is_checked"></b-form-checkbox>
          </template>

          <template v-slot:cell(order_date)="data">
            {{ displayDate(data.item.order_date) }}
          </template>

          <template v-slot:cell(cn_number)="data">
            <router-link :to="{
              name: 'collection_note_detail',
              params: { collection_note_id: data.item.id }
            }">
              {{ data.item.cn_number }}
            </router-link>
          </template>

          <template v-slot:cell(payment_status)="data">
            -
          </template>

          <template v-slot:cell(order_import_status)="data">
            <div>

              <span class="span-status">{{ data.item.order_import_status }}</span>

              <span v-if="data.item.order_import_status == 'cancel'" class="dot_red"></span>
              <span v-if="data.item.order_import_status == 'hold'" class="dot_red"></span>
              <span v-if="data.item.order_import_status == 'pending'" class="dot_yellow"></span>
              <span v-if="data.item.order_import_status == 'received'" class="dot_green"></span>

            </div>
          </template>

          <template v-slot:cell(stock_status)="data">
            <div>

              <span class="span-status">{{ data.item.stock_status }}</span>

              <span v-if="data.item.stock_status == '-'" class="dot_white"></span>
              <span v-if="data.item.stock_status == 'OOS'" class="dot_red"></span>
              <span v-if="data.item.stock_status == 'available'" class="dot_yellow"></span>
              <span v-if="data.item.stock_status == 'committed'" class="dot_green"></span>

            </div>
          </template>

          <template v-slot:cell(fulfilment_status)="data">
            <div>

              <span class="span-status">{{ data.item.fulfilment_status }}</span>

              <span v-if="data.item.fulfilment_status == '-'" class="dot_white"></span>
              <span v-if="data.item.fulfilment_status == 'pending'" class="dot_yellow"></span>
              <span v-if="data.item.fulfilment_status == 'completed'" class="dot_green"></span>
              <span v-if="data.item.fulfilment_status == 'fulfiled'" class="dot_green"></span>

            </div>
          </template>

          <!-- <template v-slot:cell(delivery_status)="data">
          <div>
            
            <span v-if="data.item.delivery_status == '-'" class="dot_white"></span>
            <span v-if="data.item.delivery_status == 'pending'" class="dot_yellow"></span>
            <span v-if="data.item.delivery_status == 'completed'" class="dot_green"></span>
            <span v-if="data.item.delivery_status == 'fulfiled'" class="dot_green"></span>

          </div>
        </template> -->

          <template v-slot:cell(action)="data">
            <b-button v-if="data.item.order_import_status != 'received'" class="btn-action" size="sm" variant="success"
              @click="doReceiveOrder(data.item)">Receive</b-button>

            <b-button v-if="data.item.order_import_status == 'received' &&
              data.item.stock_status != 'committed'
              " class="btn-action" size="sm" variant="success" @click="doCommitOrder(data.item)">Commit</b-button>

            <!-- <b-button
            v-if="data.item.stock_status == 'committed'"
            class="btn-action"
            size="sm"
            variant="success"
            @click="doFulfillOrder(data.item)"
            >Fulfill</b-button
          > -->

            <b-button class="btn-action" size="sm" variant="danger" @click="doCancelOrder(data.item)">Cancel</b-button>

            <b-button class="btn-action" size="sm" variant="warning" @click="doHoldOrder(data.item)">Hold</b-button>
          </template>
        </b-table>

        <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
          @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
      </div>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";

const fields = [
  {
    key: "chk_box",
    label: ""
  },
  {
    key: "cn_number",
    label: "CN#"
  },
  {
    key: "vendor_name",
    label: "Vendor Name"
  },
  {
    key: "created_at",
    label: "Created at"
  },
  {
    key: "status",
    label: "Status",
    class: "txt_camelcase center_align"
  }
];

export default {
  name: "DeliveryNote",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  mixins: [apiService],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      courier_options: [],
      export_date: {
        start_at: moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD")
      },
      upload_file: [],
      loader_full: false,
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        channel_selected: null
      },
      search_criteria: {
        keyword: "",
        channel_selected: null,
        start_at: moment()
          .subtract(30, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD"),
        collection_date: moment().format("YYYY-MM-DD"),
        order_status_selected: null,
        stock_status_selected: null,
        fulfilment_status_selected: null
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      channel_options: [
        {
          value: null,
          text: "All Channel"
        }
      ],

      order_status_options: [
        {
          value: null,
          text: "All Order Status"
        },
        {
          value: "received",
          text: "Received"
        },
        {
          value: "pending",
          text: "Pending"
        }
      ],
      stock_status_options: [
        {
          value: null,
          text: "All Stock Status"
        },
        {
          value: "-",
          text: "-"
        },
        {
          value: "pending",
          text: "Pending"
        },
        {
          value: "available",
          text: "Available"
        },
        {
          value: "committed",
          text: "Committed"
        }
      ],

      fulfilment_status_options: [
        {
          value: null,
          text: "All Fulfilment Status"
        },
        {
          value: "approve",
          text: "Fulfilled"
        },
        {
          value: "pending",
          text: "Pending"
        }
      ],

      check_all_rows: false,
      outstanding_order_cnts: {},
      outstanding_stock_cnts: {}
    };
  },
  async created() {
    await this.getDeliveryNote();
    let channels_response = await this.getChannels(this.$store.state.user_obj);
    for (let i in channels_response.channels) {
      this.channel_options.push({
        value: channels_response.channels[i].name,
        text: channels_response.channels[i].name
      });
    }
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  watch: {
    // whenever changes, this function will run
    check_all_rows: function (new_val, old_val) {
      // this.check_all_rows = !this.check_all_rows;
      console.log("check_all_rows");
      if (new_val == "all") {
        // Check all
        for (let i in this.items) {
          this.items[i].is_checked = true;
        }
      } else {
        for (let i in this.items) {
          this.items[i].is_checked = false;
        }
      }
      console.log(this.items);
    }
  },
  methods: {
    exportCSV() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url: this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          export_type: "collection_note",
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "collection_note.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async bulkDownloadWayBill() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "note_bulk_download.php",
        data: {
          items: this.items
        }
      });
      if (response.data.url) {
        window.open(response.data.url, "_blank");
      }
      this.loader.hide();
    },

    async updateImportStatus(row_data, status) {
      if (status == "cancel") {
        return;
      }
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "collection_note_approval.php",
        data: {
          status: status,
          collection_note_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });
      this.getDeliveryNote();
    },

    async doReceiveOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "collection_note_receive.php",
        data: {
          collection_note_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Receive Order Success",
        variant: "success"
      });
      this.getDeliveryNote();
    },

    async doCommitOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "collection_note_commit.php",
        data: {
          collection_note_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Commit Order Success",
        variant: "success"
      });
      this.getDeliveryNote();
    },

    async doCancelOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "collection_note_cancel.php",
        data: {
          collection_note_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Cancel Order Success",
        variant: "success"
      });
      this.getDeliveryNote();
    },

    async doHoldOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "collection_note_hold.php",
        data: {
          collection_note_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Cancel Order Success",
        variant: "success"
      });
      this.getDeliveryNote();
    },

    async doFulfillOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "collection_note_fulfil.php",
        data: {
          collection_note_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Fulfil Order Success",
        variant: "success"
      });
      this.getDeliveryNote();
    },

    async updateFulfillStatus(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "collection_note_fulfill.php",
        data: {
          collection_note_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });
      this.getDeliveryNote();
    },

    async getDeliveryNote() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "collection_note_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      this.items = response.data.collection_notes;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    onSearch() {
      this.getDeliveryNote();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getDeliveryNote();
    },

    downloadWaybill(data) {
      let url = process.env.WAYBILL_HOST + "/waybill?";
      url += "id=" + data.tracking_number;
      window.open(url, "_blank");
    },

    async onBulkAction(bulk_action) {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let collection_note_ids = [];
      for (let i in this.items) {
        if (this.items[i].is_checked) {
          collection_note_ids.push(this.items[i].id);
        }
      }

      // call action
      let action_urls = {
        receive: "collection_note_receive.php",
        commit: "collection_note_commit.php",
        fulfill: "collection_note_fulfill.php"
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: action_urls[bulk_action],
        data: {
          collection_note_ids: collection_note_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Bulk Update Success",
        variant: "success"
      });
      this.getDeliveryNote();
    },

    async onBulkApprove() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });
      let collection_note_ids = [];
      for (let i in this.items) {
        if (
          this.items[i].is_checked &&
          this.items[i].order_import_status == "pending"
        ) {
          collection_note_ids.push(this.items[i].id);
        }
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "collection_note_approval.php",
        data: {
          status: status,
          collection_note_ids: collection_note_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });
      this.getDeliveryNote();
    },

    async onBulkFulfill() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });
      let collection_note_ids = [];
      for (let i in this.items) {
        if (
          this.items[i].is_checked &&
          this.items[i].order_import_status != "pending" &&
          this.items[i].fulfilment_status == "pending"
        ) {
          collection_note_ids.push(this.items[i].id);
        }
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "collection_note_fulfill.php",
        data: {
          status: status,
          collection_note_ids: collection_note_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });
      this.getDeliveryNote();
    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);
      formData.append("user_id", this.$store.state.user_obj.user_id);
      formData.append("client_id", this.$store.state.user_obj.client_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "collection_note_import.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });

      if (response) {
        this.loader_full.hide();
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Upload Success",
          variant: "success"
        });
        this.getDeliveryNote();
      }
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.is_checked) return "table-info";
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.span-status {
  display: none;
}

.container-status:hover .span-status {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/CollectionNote.vue